import api from "./api";

export const getHubSummary = async (hubId) => {
  const res = await api.get(`/statistics/hub/${hubId}/summary`);
  return res.data?.data ?? null;
};

export const getHubEventBreakdown = async (hubId, status) => {
  const params = status !== undefined && status !== null ? { status } : {};
  const res = await api.get(`/statistics/hub/${hubId}/events`, { params });
  const data = res.data?.data;
  if (!data) return { chartData: [], events: [] };
  return {
    chartData: data.chartData?.$values ?? data.chartData ?? [],
    events: data.events?.$values ?? data.events ?? [],
  };
};